export default "__VITE_ASSET__CN1OgwpT__"